/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { AnyAction, createSlice, Dispatch, Middleware, MiddlewareAPI, Slice } from '@reduxjs/toolkit';
import { RootState } from './reducer';

interface InitialState {
    pendingRequests: number;
}

const initialState: InitialState = {
    pendingRequests: 0,
};

const loadingSlice = createSlice({
    name: 'loading',
    initialState: initialState,
    reducers: {
        startLoading: state => {
            state.pendingRequests++;
        },
        stopLoading: state => {
            state.pendingRequests--;
        },
    },
});

export const loadingMiddleware =
    (slice: Slice): Middleware =>
    (storeApi: MiddlewareAPI<Dispatch, RootState>) =>
    (next: Dispatch<AnyAction>) =>
    (action: AnyAction) => {
        const actionType = action.type;
        if (actionType?.endsWith('/pending')) {
            storeApi.dispatch(loadingSlice.actions.startLoading());
        }

        if (actionType?.endsWith('/fulfilled') || actionType?.endsWith('/rejected')) {
            storeApi.dispatch(loadingSlice.actions.stopLoading());
        }
        return next(action);
    };
export const loadingActions = loadingSlice.actions;
export default loadingSlice.reducer;
